import api from "../../utils/api";

export const GET_CHALLENGES = "GET_CHALLENGES";
export const GET_OWN_CHALLENGES = "GET_OWN_CHALLENGES";
export const CREATE_CHALLENGE = "CREATE_CHALLENGE";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_SPECIFIC_USER = "GET_SPECIFIC_USER";
export const GET_RANKING = "GET_RANKING";
export const CREATE_COMPANY = "CREATE_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const UPDATE_USER = "UPDATE_USER";
export const ADD_CHALLENGE = "ADD_CHALLENGE";
export const REMOVE_CHALLENGE = "REMOVE_CHALLENGE";
export const EDIT_PROFILE_NAME = "EDIT_PROFILE_NAME";
export const EDIT_PROFILE_LASTNAME = "EDIT_PROFILE_LASTNAME";
export const CLEAR_CHALLENGE_MSG = "CLEAR_CHALLENGE_MSG";
export const GET_COMPANY = "GET_COMPANY";
export const CLEAR_COMPANY_MSG = "CLEAR_COMPANY_MSG";
export const GET_SPECIFIC_CHALLENGE = "GET_SPECIFIC_CHALLENGE";
export const EMPTY_SPECIFIC_CHALLENGE = "EMPTY_SPECIFIC_CHALLENGE";
export const CREATE_STAGE = "CREATE_STAGE";
export const EDIT_STAGE = "EDIT_STAGE";
export const DELETE_STAGE = "DELETE_STAGE";
export const CREATE_CONTENT = "CREATE_CONTENT";
export const DELETE_CONTENT = "DELETE_CONTENT";
export const GET_SPECIFIC_CONTENT = "GET_SPECIFIC_CONTENT";
export const GET_STAGES = "GET_STAGES";
export const GET_SPECIFIC_STAGE = "GET_SPECIFIC_STAGE";
export const EDIT_CONTENT = "EDIT_CONTENT";
export const RESET_CONTENT_STATE = "RESET_CONTENT_STATE";
export const COMPLETE_CONTENT = "COMPLETE_CONTENT";
export const GET_QUESTIONS = "GET_QUESTIONS";
export const GET_USER_POINTS = "GET_USER_POINTS";
export const GET_COMPANY_POINTS = "GET_COMPANY_POINTS ";
export const GET_JSON = "GET_JSON";
export const GET_CHALLENGE_ADMIN_DETAILS = "GET_CHALLENGE_ADMIN_DETAILS";
export const COMPLETE_EXAM = "COMPLETE_EXAM";
export const COMPLETE_EXAM2 = "COMPLETE_EXAM2";
export const SORT_BY_POINTS = "SORT_BY_POINTS";
export const SORT_BY_POSITION = "SORT_BY_POSITION";
export const SORT_BY_PERCENT = "SORT_BY_PERCENT";
export const SORT_BY_NAME = "SORT_BY_NAME";
export const LOOK_BY_NAME = "LOOK_BY_NAME";
export const UPDATE_MEDAL = "UPDATE_MEDAL";
export const UPDATE_CHALLENGE = "UPDATE_CHALLENGE";
export const GET_EXAMS = "GET_EXAMS";
export const SOCIAL_NOTIS = "SOCIAL_NOTIS";
export const GET_SOCIAL = "GET_SOCIAL";
export const UPDATE_SOCIAL = "UPDATE_SOCIAL";
export const GET_USERS_BY_COMPANY = "GET_USERS_BY_COMPANY";
export const GIVE_ADMIN = "GIVE_ADMIN";
export const GET_COMPANIES = "GET_COMPANIES";
export const CHANGE_COMPANY = "CHANGE_COMPANY";
export const SOCIAL_REVIEW = "SOCIAL_REVIEW";
export const CLEAR_SOCIAL = "CLEAR_SOCIAL";
export const CLEAN_BADGES = "CLEAN_BADGES";
export const GET_COMPANY_USERS_INFO = "GET_COMPANY_USERS_INFO";
export const GET_ALL_CHALLENGES = "GET_ALL_CHALLENGES";

// Crear usuario
// export function sendUser(user) {
//   return function (dispatch) {
//     console.log("Enviando la solicitud:", user);
//     return axios
//       .post(`/user`, user, {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       })
//       .then((response) => {
//         dispatch({
//           type: "POST_USER",
//           payload: response.data,
//         });
//         console.log("Usuario creado con éxito:", response.data);
//       })
//       .catch((error) => {
//         console.error("Error al crear usuario:", error);
//         dispatch({
//           type: "POST_USER_ERROR",
//           error: error,
//         });
//         throw error;
//       });
//   };
// }

export function sendUser(user) {
  return async function (dispatch) {
    try {
      const response = await api.post(`/user`, user);
      dispatch({ type: "POST_USER", payload: response.data });
    } catch (error) {
      console.error("Error al crear usuario:", error);
      const errorMessage =
        error.response?.data?.message || "Error al crear usuario.";
      dispatch({ type: "POST_USER_ERROR", payload: errorMessage });
      console.error("Error al crear usuario:", error);
      throw error;
    }
  };
}

export const getChallenges = (id) => {
  return async function (dispatch) {
    try {
      const challenges = await api.get(
        `/companyChallenge?id=${id}&rol=admin`
      );
      // console.log("Challenges obtenidos:", challenges.data);
      return dispatch({ type: GET_CHALLENGES, payload: challenges.data });
    } catch (error) {
      // console.error("Error al obtener challenges:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al obtener la información de los retos.";
      // console.error("Error al obtener challenges:", error);
      return dispatch({
        type: "GET_CHALLENGES_ERROR",
        payload: errorMessage,
      });
    }
  };
};

//buscar organizacion por id

export const getCompany = (id) => {
  return async function (dispatch) {
    if (!id) return;
    try {
      const company = await api.get(`/company?id=${id}`);
      // console.log("Información de la organización obtenida:", company.data);
      return dispatch({ type: GET_COMPANY, payload: company.data });
    } catch (error) {
      // console.error("Error al obtener información de la organización:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al obtener la información de la Organización.";
      // console.error("Error al obtener información de la organización:", error);
      return dispatch({
        type: "GET_COMPANY_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const getOwnChallenges = (id) => {
  return async function (dispatch) {
    try {
      const challenges = await api.get(`/companyChallenge?id=${id}&rol=user`);
      // console.log("Retos propios obtenidos:", challenges.data);
      return dispatch({ type: GET_OWN_CHALLENGES, payload: challenges.data });
    } catch (error) {
      console.error("Error al obtener retos propios:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al obtener la información de los retos.";
      console.error("Error al obtener retos propios:", error);
      return dispatch({
        type: "GET_OWN_CHALLENGES_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const getSpecificChallenge = (id) => {
  return async function (dispatch) {
    try {
      const challenge = await api.get(`/challenge?id=${id}`);
      // console.log("Reto específico obtenido:", challenge.data);
      return dispatch({
        type: GET_SPECIFIC_CHALLENGE,
        payload: challenge.data,
      });
    } catch (error) {
      // console.error("Error al obtener reto específico:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al obtener la información del reto.";
      // console.error("Error al obtener reto específico:", error);
      return dispatch({
        type: "GET_SPECIFIC_CHALLENGE",
        payload: errorMessage,
      });
    }
  };
};

export const getChallengeAdminDetails = (id) => {
  return async function (dispatch) {
    try {
      const challengeAdminDetails = await api.get(`/points/challenge/${id}`);
      // console.log(
      //   "Detalles de reto para el administrador obtenidos:",
      //   challengeAdminDetails.data
      // );
      return dispatch({
        type: GET_CHALLENGE_ADMIN_DETAILS,
        payload: challengeAdminDetails.data,
      });
    } catch (error) {
      console.error(
        "Error al obtener detalles de reto para el administrador:",
        error
      );
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al obtener la información del reto para los detalles del administrador.";
      console.error(
        "Error al obtener detalles de reto para el administrador:",
        error
      );
      return dispatch({
        type: "GET_CHALLENGE_ADMIN_DETAILS_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const createChallenge = (fields, id) => {
  return async function (dispatch) {
    try {
      const challenge = await api.post(`/challenge/${id}`, fields);
      // console.log("Reto creado exitosamente:", challenge.data.challengeUpdated);
      return dispatch({
        type: CREATE_CHALLENGE,
        payload: challenge.data.challengeUpdated,
      });
    } catch (error) {
      console.error("Error al crear reto:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al crear el reto.";
      console.error("Error al crear reto:", error);
      return dispatch({
        type: "CREATE_CHALLENGE_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const addChallenge = (idCompany, idChallenge) => {
  return async function (dispatch) {
    try {
      const challenge = await api.put(`companyChallenge/copy/${idCompany}`, {
        challengeId: idChallenge,
      });
      // console.log(
      //   "Reto agregado exitosamente:",
      //   challenge.data.challengeUpdated
      // );
      return dispatch({
        type: ADD_CHALLENGE,
        payload: challenge.data.challengeUpdated,
      });
    } catch (error) {
      console.error("Error al agregar reto:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al crear el reto.";
      console.error("Error al agregar reto:", error);
      return dispatch({
        type: "ADD_CHALLENGE_ERROR",
        payload: errorMessage,
      });
    }
  };
};

//Remover challenge

export const removeChallenge = (idCompany, idChallenge) => {
  return async function (dispatch) {
    try {
      const challenge = await api.put(
        `/companyChallenge/remove/${idCompany}`,
        {
          challengeId: idChallenge,
        }
      );
      // console.log("Reto eliminado exitosamente:", challenge.data.challengeId);
      return dispatch({
        type: REMOVE_CHALLENGE,
        payload: challenge.data.challengeId,
      });
    } catch (error) {
      console.error("Error al eliminar reto:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al crear el reto.";
      console.error("Error al eliminar reto:", error);
      return dispatch({
        type: "REMOVE_CHALLENGE_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const getStages = (idChallenge) => {
  return async function (dispatch) {
    try {
      const stages = await api.get(`/stage/${idChallenge}`);
      // console.log("Retos obtenidos:", stages.data);
      return dispatch({
        type: GET_STAGES,
        payload: stages.data,
      });
    } catch (error) {
      console.error("Error al obtener retos:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al traer los retos.";
      console.error("Error al obtener retos:", error);
      return dispatch({
        type: "GET_STAGES_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const getSpecificStage = (idStage) => {
  return async function (dispatch) {
    try {
      const stage = await api.get(`/stage/specific/${idStage}`);
      // console.log("Reto específico obtenido:", stage.data);
      return dispatch({
        type: GET_SPECIFIC_STAGE,
        payload: stage.data,
      });
    } catch (error) {
      console.error("Error al obtener reto específico:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al traer ese reto, master.";
      console.error("Error al obtener reto específico:", error);
      return dispatch({
        type: "GET_SPECIFIC_STAGE",
        payload: errorMessage,
      });
    }
  };
};

//Crear reto

export const createStage = (idChallenge, title, startDate, endDate) => {
  return async function (dispatch) {
    try {
      const stage = await api.post(`/stage/${idChallenge}`, {
        name: title,
        start: startDate,
        end: endDate,
      });
      // console.log("Reto creado exitosamente:", stage.data);
      return dispatch({
        type: CREATE_STAGE,
        payload: stage.data,
      });
    } catch (error) {
      console.error("Error al crear reto:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al crear el reto.";
      console.error("Error al crear reto:", error);
      return dispatch({
        type: "CREATE_STAGE_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const editStage = (idStage, content) => {
  return async function (dispatch) {
    try {
      const updatedStage = await api.put(`/stage/${idStage}`, content);
      // console.log("Reto editado exitosamente:", updatedStage.data);
      return dispatch({
        type: EDIT_STAGE,
        payload: updatedStage.data,
      });
    } catch (error) {
      console.error("Error al editar reto:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al editar el reto.";
      console.error("Error al editar reto:", error);
      return dispatch({
        type: "EDIT_STAGE_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const deleteStage = (idStage, idChallenge) => {
  return async function (dispatch) {
    try {
      const deletedStage = await api.delete(
        `/stage/${idStage}/${idChallenge}`
      );
      // console.log("Reto eliminado exitosamente:", deletedStage.data);
      return dispatch({
        type: DELETE_STAGE,
        payload: deletedStage.data,
      });
    } catch (error) {
      console.error("Error al eliminar reto:", error);
      const errorMessage =
        error.response?.data?.message || "Master, no se pudo borrar el reto.";
      console.error("Error al eliminar reto:", error);
      return dispatch({
        type: "DELETE_STAGE_ERROR",
        payload: errorMessage,
      });
    }
  };
};

//Crear contenido

export const createContent = (idStage, content) => {
  return async function (dispatch) {
    try {
      const createdContent = await api.post(`/content/${idStage}`, content);
      // console.log("Contenido creado exitosamente:", createdContent.data);
      return dispatch({
        type: CREATE_CONTENT,
        payload: createdContent.data,
      });
    } catch (error) {
      console.error("Error al crear el contenido:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al crear el contenido.";
      console.error("Error al crear el contenido:", error);
      return dispatch({
        type: "CREATE_CONTENT_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const editContent = (idStage, content) => {
  return async function (dispatch) {
    try {
      const updatedContent = await api.put(`/content/${idStage}`, content);
      // console.log("Contenido editado exitosamente:", updatedContent.data);
      return dispatch({
        type: EDIT_CONTENT,
        payload: updatedContent.data,
      });
    } catch (error) {
      console.error("Error al editar el contenido:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al editar el contenido.";
      console.error("Error al editar el contenido:", error);
      return dispatch({
        type: "EDIT_CONTENT_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const deleteContent = (stageId, contentId) => {
  return async function (dispatch) {
    try {
      const deletedContent = await api.delete(
        `/content?stageId=${stageId}&contentId=${contentId}`
      );
      // console.log("Contenido eliminado exitosamente:", deletedContent.data);
      return dispatch({
        type: DELETE_CONTENT,
        payload: deletedContent.data,
      });
    } catch (error) {
      console.error("Error al eliminar el contenido:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Master, no se pudo borrar el contenido.";
      console.error("Error al eliminar el contenido:", error);
      return dispatch({
        type: "DELETE_CONTENT_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const completeContent = (
  userId,
  challengeId,
  contentId,
  rating,
  available
) => {
  return async function (dispatch) {
    try {
      const completedContent = await api.post(
        `/points`,
        { userId, contentId, challengeId, rating, available }
      );
      // console.log("Contenido completado exitosamente:", completedContent.data);
      dispatch({
        type: COMPLETE_CONTENT,
        payload: completedContent.data,
      });
      return dispatch(getUserPoints(userId));
    } catch (error) {
      console.error("Error al completar el contenido:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Master, no se pudo completar el contenido.";
      console.error("Error al completar el contenido:", error);
      return dispatch({
        type: "COMPLETE_CONTENT_ERROR",
        payload: errorMessage,
      });
    }
  };
};

//Limpir estado de content
export const resetContentState = () => {
  // console.log("Resetting content state");
  return {
    type: RESET_CONTENT_STATE,
    payload: {},
  };
};

//Traer contenido especifico GET_SPECIFIC_CONTENT
export const getSpecificContent = (idContent, challengeId) => {
  return async function (dispatch) {
    // console.log(
    //   `Obteniendo contenido específico con id ${idContent} y id de desafío ${challengeId}`
    // );
    try {
      const contenidoEspecifico = await api.get(
        `/content?challengeId=${challengeId}&contentId=${idContent}`
      );
      // console.log(
      //   `Contenido específico obtenido con id ${idContent} y id de desafío ${challengeId}`
      // );
      return dispatch({
        type: GET_SPECIFIC_CONTENT,
        payload: contenidoEspecifico.data,
      });
    } catch (error) {
      console.error("Error en getSpecificContent:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al obtener el contenido.";
      console.error(errorMessage);
      return dispatch({
        type: "GET_SPECIFIC_CONTENT_ERROR",
        payload: errorMessage,
      });
    }
  };
};

// Buscar usuario
export const getUser = () => {
  return async function (dispatch) {
    // console.log("Obteniendo todos los usuarios");
    try {
      const response = await api.get("/user");
      // console.log(`Usuarios obtenidos: ${response.data}`);
      dispatch({ type: GET_ALL_USERS, payload: response.data });
    } catch (error) {
      console.error("Error en getUser:", error);
      throw error;
    }
  };
};

// Buscar usuario exacto
export const getSpecificUser = (id) => {
  return async function (dispatch) {
    if (!id) return;
    // console.log(`Buscando usuario específico con id ${id}`);
    try {
      const user = await api.get(`/user?id=${id}`);
      // console.log(`Usuario específico encontrado con id ${id}: ${user.data}`);
      return dispatch({ type: GET_SPECIFIC_USER, payload: user.data });
    } catch (error) {
      console.error("Error en getSpecificUser:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al obtener el usuario.";
      console.error(errorMessage);
      return dispatch({
        type: "GET_SPECIFIC_USER_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const updateUser = (id, fields) => {
  return async function (dispatch) {
    // console.log(`Actualizando usuario con id ${id}`);
    try {
      const user = await api.put(`/user/${id}`, fields);
      // console.log(`Usuario actualizado con id ${id}: ${user.data}`);
      return dispatch({ type: UPDATE_USER, payload: user.data });
    } catch (error) {
      console.error("Error en updateUser:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al actualizar el usuario.";
      console.error(errorMessage);
      dispatch({
        type: "UPDATE_USER_ERROR",
        payload: errorMessage,
      });
      return { success: false, errorMessage };
    }
  };
};

// LLamado temporal dashboard
// export const getRanking = () => {
//   return async function (dispatch) {
//     console.log("Obteniendo datos de ranking");
//     try {
//       const response = await fetch("/data/fakeData.json");
//       const data = await response.json();
//       console.log("Datos de ranking obtenidos:", data);
//       return dispatch({ type: GET_RANKING, payload: data });
//     } catch (error) {
//       console.error("getRanking error:", error);
//       const errorMessage =
//         error.message || "Ha ocurrido un error al obtener la información.";
//       console.error(errorMessage);
//       return dispatch({
//         type: "GET_RANKING_ERROR",
//         payload: errorMessage,
//       });
//     }
//   };
// };

// Crear compañía
export const createCompany = (fields) => {
  return async function (dispatch) {
    // console.log("Creando compañía");
    try {
      const company = await api.post("/company", fields);
      // console.log("Compañía creada:", company.data);
      return dispatch({ type: CREATE_COMPANY, payload: company.data });
    } catch (error) {
      console.error("createCompany error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al crear la compañía.";
      console.error(errorMessage);
      return dispatch({
        type: "CREATE_COMPANY_ERROR",
        payload: errorMessage,
      });
    }
  };
};

// Actualizar compañía
export const updateCompany = (id, data) => {
  return async function (dispatch) {
    //console.log(`Actualizando compañía con id ${id}`);
    try {
      const company = await api.put(`/company/${id}`, data);
      // console.log(`Compañía actualizada con id ${id}:`, company.data);
      return dispatch({ type: UPDATE_COMPANY, payload: company.data });
    } catch (error) {
      console.error("updateCompany error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al actualizar la compañía.";
      console.error(errorMessage);
      return dispatch({
        type: "UPDATE_COMPANY_ERROR",
        payload: errorMessage,
      });
    }
  };
};

// Editar Nombre en Profile
export const editProfileName = (field) => {
  // console.log("Editando nombre en perfil");
  return {
    type: EDIT_PROFILE_NAME,
    payload: field,
  };
};

// Editar Apellido en Profile
export const editProfileLastname = (field) => {
  // console.log("Editando apellido en perfil");
  return {
    type: EDIT_PROFILE_LASTNAME,
    payload: field,
  };
};

//Borrar estado con mensaje de creación de challenge.
export const clearChallengeMsg = () => {
  //console.log("Borrando mensaje de creación de reto");
  return {
    type: CLEAR_CHALLENGE_MSG,
  };
};

//Borrar estado con mensaje de creación de Organización.
export const clearCompanyMsg = () => {
  // console.log("Borrando mensaje de creación de compañía");
  return {
    type: CLEAR_COMPANY_MSG,
  };
};

// Vaciar Get Specific Challenge
export const clearSpecificChallenge = () => {
  // console.log("Vaciando información de reto específico");
  return {
    type: EMPTY_SPECIFIC_CHALLENGE,
  };
};

// Traer las preguntas de la quiz
export const getQuestions = () => {
  return function (dispatch) {
    // console.log("Obteniendo preguntas de la quiz");
    return fetch(`./data/reactQuizTest.json`)
      .then((respuesta) => respuesta.json())
      .then((response) => {
        // console.log("Preguntas obtenidas:", response);
        return dispatch({ type: GET_QUESTIONS, payload: response });
      })
      .catch((error) => {
        console.error("getQuestions error:", error);
        const errorMessage = "Error al obtener las preguntas";
        console.error(errorMessage);
        return dispatch({ type: "GET_QUESTIONS_ERROR", payload: errorMessage });
      });
  };
};

//traeme el json padre
export const getJson = () => {
  return async function (dispatch) {
    // console.log("Obteniendo JSON padre");
    try {
      const jason = await api.get("/json");
      //console.log("JSON padre obtenido:", jason.data);
      return dispatch({ type: GET_JSON, payload: jason.data });
    } catch (error) {
      console.error("getJson error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al obtener el JSON padre.";
      console.error(errorMessage);
      return dispatch({
        type: "GET_JSON_ERROR",
        payload: errorMessage,
      });
    }
  };
};

//traer los puntos
export const getUserPoints = (userId) => {
  return async function (dispatch) {
    //console.log(`Obteniendo puntos del usuario con id ${userId}`);
    try {
      const points = await api.get(`/points/user/${userId}`);
      // console.log(
      //   `Puntos del usuario con id ${userId} obtenidos:`,
      //   points.data
      // );
      return dispatch({
        type: GET_USER_POINTS,
        payload: points.data,
      });
    } catch (error) {
      console.error("getUserPoints error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Error al obtener los puntos del usuario.";
      console.error(errorMessage);
      return dispatch({
        type: "GET_USER_POINTS_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const getCompanyPoints = (companyId) => async (dispatch) => {
  // console.log(`Obteniendo puntos de la compañía con id ${companyId}`);
  try {
    const response = await api.get(`/points/company/${companyId}`);
    const sortedData = response.data.sort(
      (a, b) => b.totalPointsEarned - a.totalPointsEarned
    );
    // console.log(
    //   `Puntos de la compañía con id ${companyId} obtenidos:`,
    //   sortedData
    // );
    dispatch({ type: GET_COMPANY_POINTS, payload: sortedData });
  } catch (error) {
    console.error("getCompanyPoints error:", error);
    const errorMessage =
      error.response?.data?.message ||
      "Error al obtener los puntos de la compañía.";
    console.error(errorMessage);
    dispatch({ type: "GET_COMPANY_POINTS_ERROR", payload: errorMessage });
  }
};

export const completeExam =
  (
    idUser,
    answers,
    files,
    contentId,
    stageName,
    challengeId,
    url,
    fileName,
    name
  ) =>
  async (dispatch) => {
    //console.log(`Completando examen para usuario con id ${idUser}`);
    try {
      const response = await api.post(`/exam`, {
        userId: idUser,
        exam: {
          ...answers,
          contentId,
          files,
          challengeId,
          stageName,
          url,
          name,
        },
      });
      const { data } = response;
      // console.log(
      //   `Examen completado para usuario con id ${idUser}. Datos de respuesta:`,
      //   data
      // );
      dispatch({ type: COMPLETE_EXAM, payload: data });
    } catch (error) {
      console.error("completeExam error:", error);
      const errorMessage =
        error.response?.data?.message || "Error al completar el examen.";
      console.error(errorMessage);
      dispatch({ type: "COMPLETE_EXAM_ERROR", payload: errorMessage });
    }
  };

export const completeExam2 = (idUser, contentId) => async (dispatch) => {
  //console.log(`Completando examen 2 para usuario con id ${idUser}`);
  try {
    const response = await api.post(`/exam`, {
      userId: idUser,
      exam: {
        contentId: contentId,
      },
    });
    const { data } = response;
    // console.log(
    //   `Examen 2 completado para usuario con id ${idUser}. Datos de respuesta:`,
    //   data
    // );
    dispatch({ type: COMPLETE_EXAM2, payload: data });
  } catch (error) {
    console.error("completeExam2 error:", error);
    const errorMessage =
      error.response?.data?.message || "Error al completar el examen.";
    console.error(errorMessage);
    dispatch({ type: "COMPLETE_EXAM2_ERROR", payload: errorMessage });
  }
};

export const deletePict = (id) => {
  return async function (dispatch) {
    // console.log(`Eliminando foto con id ${id}`);
    try {
      const response = await api.delete(`/pictures/${id}`);
      // console.log(
      //   `Foto con id ${id} eliminada. Respuesta del servidor:`,
      //   response.data
      // );
      dispatch({ type: "DELETE_PICT_SUCCESS", payload: response.data });
    } catch (error) {
      console.error("deletePict error:", error);
      dispatch({ type: "DELETE_PICT_ERROR", error });
    }
  };
};

export const sortByPoints = (option) => {
  //console.log(`Ordenando por puntos (${option})`);
  return {
    type: SORT_BY_POINTS,
    payload: option,
  };
};
export const sortByPosition = (option) => {
  // console.log(`Ordenando por posición (${option})`);
  return {
    type: SORT_BY_POSITION,
    payload: option,
  };
};

export const sortByPercent = (option) => {
  // console.log(`Ordenando por porcentaje (${option})`);
  return {
    type: SORT_BY_PERCENT,
    payload: option,
  };
};

export const sortByName = (option) => {
  // console.log(`Ordenando por nombre (${option})`);
  return {
    type: SORT_BY_NAME,
    payload: option,
  };
};

export const lookByName = (option, backup) => {
  // console.log(`Buscando por nombre (${option})`);
  return {
    type: LOOK_BY_NAME,
    payload: [option, backup],
  };
};

export const updateMedal = (userId, badgeId) => async (dispatch) => {
  try {
    const response = await api.put(`/notification/${userId}`, {
      badgeId: badgeId,
    });
    const { badges } = response.data;
    dispatch({ type: UPDATE_MEDAL, payload: badges });
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Error al actualizar la medalla.";
    dispatch({ type: "UPDATE_MEDAL_ERROR", payload: errorMessage });
  }
};

export const cleanBadges = (option) => {
  return {
    type: CLEAN_BADGES,
  };
};

export const updateChallenge = (id, body) => {
  return async (dispatch) => {
    // console.log(id, body);
    try {
      const response = await api.put(`/challenge/${id}`, body);
      dispatch({
        type: UPDATE_CHALLENGE,
        payload: response.data,
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getExams = (userId, challengeId) => {
  return async function (dispatch) {
    try {
      const exams = await api.get(
        `/exam/${userId}/${challengeId}`
      );
      // console.log("getExams: Exámenes obtenidos con éxito", exams);
      return dispatch({ type: GET_EXAMS, payload: exams.data });
    } catch (error) {
      // console.log("getExams: error", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ha ocurrido un error al obtener la información de los retos.";
      return dispatch({
        type: "GET_EXAMS_ERROR",
        payload: errorMessage,
      });
    }
  };
};

export const socialNotis = (challengeId, stageId, userId) => {
  return async (dispatch) => {
    try {
      const response = await api.post(`/social/stage`, {
        challengeId: challengeId,
        userId: userId,
        stageId: stageId,
      });
      // console.log("socialNotis: Notificación social enviada", response);
      dispatch({
        type: SOCIAL_NOTIS,
        payload: response.data,
      });
    } catch (error) {
      console.error("socialNotis: error", error);
    }
  };
};

export const getSocial = (challengeId) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/social/${challengeId}`);
      // console.log("getSocial: Datos sociales obtenidos con éxito", response);
      dispatch({
        type: GET_SOCIAL,
        payload: response.data,
      });
    } catch (error) {
      if (error.response && error.response.status === 400) {
        //  console.log("getSocial: No se encontraron interacciones");
      } else {
        console.error("getSocial: error", error);
      }
    }
  };
};

export const updateSocial = (challengeId, noticia) => {
  return async (dispatch) => {
    try {
      const response = await api.put(`/social/${challengeId}`, noticia);
      // console.log(
      //   "updateSocial: Datos sociales actualizados con éxito",
      //   response
      // );
      dispatch({
        type: UPDATE_SOCIAL,
        payload: response.data,
      });
    } catch (error) {
      console.error("updateSocial: error", error);
    }
  };
};

export const socialReview = (challengeId, userId, review) => {
  return async (dispatch) => {
    try {
      const response = await api.post(`/social/review`, {
        challengeId: challengeId,
        userId: userId,
        userReview: review,
      });
      // console.log("socialReview: Reseña social enviada con éxito", response);
      dispatch({
        type: SOCIAL_REVIEW,
        payload: response.data,
      });
    } catch (error) {
      console.error("socialReview: error", error);
    }
  };
};

export const clearSocial = () => {
  // console.log("Limpiando contenido social...");
  return {
    type: CLEAR_SOCIAL,
  };
};

export const getUsersByCompany = (companyId) => {
  //console.log("Obteniendo usuarios de la compañía...");
  return async (dispatch) => {
    try {
      const response = await api.get(`/user/company/${companyId}`);
      dispatch({
        type: GET_USERS_BY_COMPANY,
        payload: response.data,
      });
    } catch (error) {
      console.error("Error al obtener usuarios por compañía:", error);
    }
  };
};

export const giveAdmin = (userId) => {
  //console.log("Otorgando permisos de administrador...");
  return async (dispatch) => {
    try {
      const response = await api.put(`/admin/${userId}`);
      dispatch({
        type: GIVE_ADMIN,
        payload: response.data,
      });
    } catch (error) {
      console.error("Error al otorgar permisos de administrador:", error);
    }
  };
};

export const getCompanies = () => {
  // console.log("Obteniendo compañías...");
  return async (dispatch) => {
    try {
      const response = await api.get(`/company/superAdmin`);
      dispatch({
        type: GET_COMPANIES,
        payload: response.data,
      });
    } catch (error) {
      console.error("Error al obtener las compañías:", error);
    }
  };
};

export const changeCompany = (userId, company, companyId, domain) => {
  // console.log("Cambiando compañía...");
  if (!userId || !company || !companyId || !domain) {
    throw new Error("Se deben proporcionar todos los argumentos.");
  }

  return async (dispatch) => {
    try {
      const response = await api.put(`/admin/company`, {
        userId,
        companyName: company,
        companyId,
        domain,
      });

      dispatch({
        type: CHANGE_COMPANY,
        payload: response.data,
      });
    } catch (error) {
      console.error("Error al cambiar la compañía:", error);
      throw new Error("No se pudo actualizar la compañía.");
    }
  };
};

export const getAllChallenges = () => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/challenge`);
      dispatch({ type: GET_ALL_CHALLENGES, payload: response.data });
    } catch (error) {
      console.error("Error al obtener todos los desafios:", error);
    }
  };
};

export const bulkCreateUsers = (companyId, users) => {
  return async () => {
    const response = await api.post(`/admin/bulk-users/${companyId}`, {
      users,
    });
    return response.data;
  };
};

export const getCompanyUsersInfo = (id) => {
  return async (dispatch) => {
    try {
      const companyUsersInfo = await api.get(`/admin/userData/${id}`);
      dispatch({
        type: GET_COMPANY_USERS_INFO,
        payload: companyUsersInfo.data,
      });
    } catch (error) {
      console.error(
        "Error al obtener la info de los usarios de la compañía:",
        error
      );
    }
  };
};

// ── Report enrichment (per-tenant custom columns, keyed by email) ──
export const getEnrichmentConfig = (companyId) => {
  return async () => {
    try {
      const res = await api.get(`/admin/enrichment/config/${companyId}`);
      return res.data?.columns || [];
    } catch (error) {
      console.error("Error al obtener la configuración de columnas:", error);
      return [];
    }
  };
};

// Dotación por dimensión (conteo liviano de enrichment — NO re-corre userData).
export const getEnrichmentStats = (companyId, groupBy) => {
  return async () => {
    try {
      const res = await api.get(
        `/admin/enrichment/stats/${companyId}?groupBy=${encodeURIComponent(groupBy)}`
      );
      return res.data || { total: 0, groups: [] };
    } catch (error) {
      console.error("Error al obtener la dotación por dimensión:", error);
      return { total: 0, groups: [] };
    }
  };
};

export const getColegioBurnup = (companyId) => {
  return async () => {
    try {
      const res = await api.get(`/admin/seguimiento/${companyId}`);
      return (
        res.data || {
          colegios: [],
          totals: { total: 0, inscritos: 0, completaron: 0 },
        }
      );
    } catch (error) {
      console.error("Error al obtener el seguimiento por colegio:", error);
      return { colegios: [], totals: { total: 0, inscritos: 0, completaron: 0 } };
    }
  };
};

export const uploadEnrichment = (companyId, rows, columns) => {
  return async () => {
    if (Array.isArray(columns)) {
      await api.put(`/admin/enrichment/config/${companyId}`, { columns });
    }
    const res = await api.post(`/admin/enrichment/upload/${companyId}`, {
      rows,
    });
    return res.data;
  };
};
